"use client";

import * as React from "react";
import { Dialog, DialogContent, DialogFooter, DialogTitle } from "@/shared/ui/dialog";
import { GetOpenNoticePopupResult } from "@/server-action/notice/get-open-notice-popup";
import { Ico16X } from "@/shared/assets/icons/ico_16_x";

interface NoticePopupProps {
  notice: GetOpenNoticePopupResult | null;
}

export function NoticePopup({ notice }: NoticePopupProps) {
  const [open, setOpen] = React.useState(!!notice);
  const [imageError, setImageError] = React.useState(false);

  if (!notice) return null;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="tb:right-30 tb:left-auto tb:translate-x-0 tb:w-100 h-auto w-[328px] gap-0 overflow-hidden rounded-[24px] border-none bg-white p-0"
        showCloseButton={false}
        noDim
      >
        <DialogTitle className="hidden"></DialogTitle>

        {/* 모바일 닫기 버튼 */}
        <button
          onClick={() => setOpen(false)}
          className="tb:hidden absolute top-5 right-5 z-10 flex h-6 w-6 items-center justify-center"
        >
          <Ico16X className="size-6" />
        </button>
        {(() => {
          const imageContent = imageError ? (
            <div className="tb:size-100 flex h-[363px] w-[328px] items-center justify-center bg-[#F6F6F6]" />
          ) : (
            <img
              src={notice.imageAttachmentUrl!}
              alt={notice.imageAttachmentFilename || notice.title}
              className="tb:size-100 h-[363px] w-[328px]"
              onError={() => setImageError(true)}
            />
          );

          return notice.linkUrl ? (
            <a
              href={notice.linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={imageError ? "cursor-pointer" : ""}
            >
              {imageContent}
            </a>
          ) : (
            imageContent
          );
        })()}

        <DialogFooter className="tb:flex hidden justify-end bg-white px-7.5 py-3">
          <button
            onClick={() => setOpen(false)}
            className="body-sm-regular flex cursor-pointer items-center gap-1 text-gray-500 focus:outline-none"
          >
            닫기
            <Ico16X />
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
